import { useEffect, useRef } from 'react';
import { isConnectorAvailable, onProxyFetchFailed } from '../lib/connector';
import { handleProxyFetchFailedEvent } from '../utils/proxyFetchFailedUI';

/**
 * Subscribes to Connector `proxy_fetch_failed` and surfaces firewall guidance via toast.
 * Mount once in AppLayout (Connector desktop only).
 */
export default function ProxyFetchFailedPrompt() {
  const unlistenRef = useRef(null);
  const subscribedRef = useRef(false);

  useEffect(() => {
    let cancelled = false;
    let pollTimer = null;

    const subscribe = async () => {
      if (cancelled || subscribedRef.current || !isConnectorAvailable()) return;
      try {
        const unlisten = await onProxyFetchFailed((payload) => {
          handleProxyFetchFailedEvent(payload);
        });
        if (cancelled) {
          if (typeof unlisten === 'function') unlisten();
          return;
        }
        unlistenRef.current = unlisten;
        subscribedRef.current = true;
      } catch (err) {
        console.error('[ProxyFetchFailed] listen failed:', err);
      }
    };

    void subscribe();

    // Connector IPC may not be ready on first paint — retry briefly.
    if (!subscribedRef.current) {
      let attempts = 0;
      pollTimer = window.setInterval(() => {
        attempts += 1;
        if (subscribedRef.current || attempts > 15) {
          window.clearInterval(pollTimer);
          return;
        }
        void subscribe();
      }, 2000);
    }

    return () => {
      cancelled = true;
      if (pollTimer) window.clearInterval(pollTimer);
      if (typeof unlistenRef.current === 'function') unlistenRef.current();
      subscribedRef.current = false;
      unlistenRef.current = null;
    };
  }, []);

  return null;
}
